/* eslint no-underscore-dangle: [error, {allow: [
  _loading, _searchMember, _nextSearchMember, _nextSearchMemberLoading,
  _profileVote, _matches, _matchesTotal, _matchesPage, _usersNotFound, _error, _message,
  _newMatch, _unseen, _noAboLimitReached,
  _newMatchMessageStatus, _newMatchMessageError
] }] */
// import _ from 'lodash';
import { EventEmitter } from 'events';
import assign from 'object-assign';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';
import MemberStore from './MemberStore';

const { ActionTypes } = Constants;
const CHANGE_EVENT = 'change';

let _loading = false;
let _searchMember = null;
let _nextSearchMember = null;
let _nextSearchMemberLoading = false;
let _profileVote = null;
let _matches = [];
let _matchesTotal = null;
let _matchesPage = 1;
let _usersNotFound = false;
let _error = false;
let _message = null;
let _newMatch = null;
let _unseen = [];
let _noAboLimitReached = false;
let _newMatchMessageStatus = null;
let _newMatchMessageError = null;

const MatchesStore = assign({}, EventEmitter.prototype, {
  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  /**
  * @param {function} callback
  */
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  /**
  * @param {function} callback
  */
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  setLoading(value) {
    _loading = value;
  },

  getLoading() {
    return _loading;
  },

  setSearchMember(member) {
    _searchMember = member;
  },

  getSearchMember() {
    return _searchMember;
  },

  setNextSearchMember(member) {
    _nextSearchMember = member;
  },

  getNextSearchMember() {
    return _nextSearchMember;
  },

  setNextSearchMemberLoading(value) {
    _nextSearchMemberLoading = value;
  },

  getNextSearchMemberLoading() {
    return _nextSearchMemberLoading;
  },

  setProfileVote(vote) {
    _profileVote = vote;
  },

  getProfileVote() {
    return _profileVote;
  },

  setMatches(matches) {
    _matches = matches;
  },

  getMatches() {
    return _matches;
  },

  setMatchesTotal(total) {
    _matchesTotal = total;
  },

  getMatchesTotal() {
    return _matchesTotal;
  },

  setMatchesPage(page) {
    _matchesPage = parseInt(page, 10);
  },

  getMatchesPage() {
    return _matchesPage;
  },

  setUsersNotFound(value) {
    _usersNotFound = value;
  },

  getUsersNotFound() {
    return _usersNotFound;
  },

  setError(value) {
    _error = value;
  },

  getError() {
    return _error;
  },

  setMessage(message) {
    _message = message;
  },

  getMessage() {
    return _message;
  },

  setNewMatch(match) {
    _newMatch = match;
  },

  getNewMatch() {
    return _newMatch;
  },

  setUnseen(ids) {
    _unseen = typeof ids === 'object' ? ids : [];
  },

  getUnseen() {
    return _unseen;
  },

  setNoAboLimitReached(value) {
    _noAboLimitReached = value;
  },

  getNoAboLimitReached() {
    return _noAboLimitReached;
  },

  setNewMatchMessageStatus(status) {
    _newMatchMessageStatus = status;
  },

  getNewMatchMessageStatus() {
    return _newMatchMessageStatus;
  },

  setNewMatchMessageError(error) {
    _newMatchMessageError = error;
  },

  getNewMatchMessageError() {
    return _newMatchMessageError;
  },
});

MatchesStore.dispatchToken = AppDispatcher.register((action) => {
  switch (action.type) {
    case ActionTypes.MATCHES_SEARCH_SUCCESS: {
      MatchesStore.setSearchMember(action.member);

      MatchesStore.setLoading(false);
      MatchesStore.emitChange();
      break;
    }
    case ActionTypes.MATCHES_SEARCH_NEXT_SUCCESS: {
      MatchesStore.setNextSearchMember(action.member);

      MatchesStore.setNextSearchMemberLoading(false);
      MatchesStore.emitChange();
      break;
    }
    case ActionTypes.MATCHES_VOTE_SUCCESS: {
      MatchesStore.setProfileVote(action.vote);
      MatchesStore.setNewMatch(action.match);
      MatchesStore.setNoAboLimitReached(action.noAboLimitReached);
      if (!action.match) {
        MatchesStore.setSearchMember(null);
      }

      MatchesStore.setLoading(action.loading);
      MatchesStore.emitChange();
      break;
    }
    case ActionTypes.MATCHES_LOAD_SUCCESS: {
      MatchesStore.setUsersNotFound(false);
      MatchesStore.setError(false);
      MatchesStore.setMessage(null);

      const totalPages = Math.ceil(action.total / action.itemsPerPage);
      if (totalPages < 5 || (parseInt(action.page, 10) + 2 >= totalPages)) {
        MemberStore.setMorePages(false, 'matches');
      } else {
        MemberStore.setMorePages(true, 'matches');
      }

      MatchesStore.setMatches(action.matches);
      MatchesStore.setMatchesTotal(action.total);
      MatchesStore.setMatchesPage(action.page);

      MatchesStore.setUnseen(action.unseen);

      MemberStore.addMembers(action.members);

      MatchesStore.setLoading(false);
      MatchesStore.emitChange();
      break;
    }
    case ActionTypes.MATCHES_LOAD_EMPTY: {
      MatchesStore.setUsersNotFound(true);
      MatchesStore.setError(false);
      MatchesStore.setMessage(action.message);

      MatchesStore.setLoading(false);
      MatchesStore.emitChange();
      break;
    }
    case ActionTypes.MATCHES_LOAD_ERROR: {
      MatchesStore.setUsersNotFound(false);
      MatchesStore.setError(true);
      MatchesStore.setMessage(action.message);

      MatchesStore.setLoading(false);
      MatchesStore.emitChange();
      break;
    }
    case ActionTypes.MATCHES_MESSAGE_SUCCESS: {
      MatchesStore.setNewMatchMessageStatus('success');
      MatchesStore.emitChange();
      break;
    }
    case ActionTypes.MATCHES_MESSAGE_FAIL: {
      MatchesStore.setNewMatchMessageStatus('error');
      MatchesStore.setNewMatchMessageError(action.message);
      MatchesStore.emitChange();
      break;
    }
    default:
      // do nothing
  }
});

module.exports = MatchesStore;
